module.exports = __webpack_public_path__ + "media/lpq_dooh_4x5.a89f6f5e.mp4";